// extracted by mini-css-extract-plugin
module.exports = {"safe_tips":"footer_safe_tips__2HeA3","topInfo":"footer_topInfo__1QMNZ","leftAddress":"footer_leftAddress__1jT1P","rightContact":"footer_rightContact__249Os"};